import React, {useEffect, useState} from 'react';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Icon from '../ui/Icon';
import Mascot from '../ui/Mascot';
import {api, getToken} from '../../lib/api';
import {currentUser} from '../../data/mock';
import styles from './MissionSidebar.module.scss';

// 任务进度侧栏，首页与任务地图共用
export default function MissionSidebar () {
    const [user, setUser] = useState(currentUser);
    const [badgeCount, setBadgeCount] = useState(currentUser.badges);

    useEffect(() => {
        api.listBadges().then(({badges}) => setBadgeCount(badges.filter(b => b.earned).length)).catch(() => {});
        if (!getToken()) return;
        api.me().then(({user: remoteUser}) => {
            setUser({
                ...currentUser,
                title: `Lv${remoteUser.level} 探险家`,
                xp: remoteUser.xp,
                streak: remoteUser.streak
            });
        }).catch(() => {});
    }, []);

    return (
        <Card className={styles.mission}>
            <div className={styles.head}>
                <div className={styles.avatar}><Mascot size={44} /></div>
                <div>
                    <div className={styles.title}>任务进度</div>
                    <div className={styles.sub}>{user.title}</div>
                </div>
            </div>
            <div className={styles.xpBadge}>
                <Icon name="bolt" size={18} />
                <span>XP：{user.xp.toLocaleString()}</span>
            </div>
            <ul className={styles.statList}>
                <li><Icon name="medal" size={18} /> 徽章：{badgeCount}</li>
            </ul>
            <div className={styles.streak}>
                <Icon name="flame" size={18} /> 连续学习：{user.streak} 天
            </div>
            <Button to="/quests" variant="primary" size="sm" block>查看地图</Button>
        </Card>
    );
}
